"use strict";

var _toConsumableArray = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _log = _interopRequireDefault(require("./helpers/log"));

var _Visitor = _interopRequireDefault(require("./Visitor"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var aggregateInfo = function aggregateInfo(info) {
  return Array.isArray(info) ? info.reduce(function (acc, info) {
    return acc.concat(aggregateInfo(info));
  }, []) : [String(info.dependency && info.dependency.getGLName() || info.initialObj)].concat(info.textureOptions ? [info.textureOptions] : []);
};
/**
 *
 */


var VisitorLogger =
/*#__PURE__*/
function (_Visitor$default) {
  _inherits(VisitorLogger, _Visitor$default);

  function VisitorLogger() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VisitorLogger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VisitorLogger)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "groupNestedLvl", 0);

    return _this;
  }

  _createClass(VisitorLogger, [{
    key: "onSurfaceGLContextChange",
    value: function onSurfaceGLContextChange(surface, gl) {
      if (gl) {
        (0, _log.default)(surface.getGLName() + " _context acquired_");
      } else {
        (0, _log.default)(surface.getGLName() + " _context lost_");
      }
    }
  }, {
    key: "onSurfaceDrawSkipped",
    value: function onSurfaceDrawSkipped() {}
  }, {
    key: "onSurfaceDrawStart",
    value: function onSurfaceDrawStart(surface) {
      var _surface$getGLSize = surface.getGLSize(),
          _surface$getGLSize2 = _slicedToArray(_surface$getGLSize, 2),
          width = _surface$getGLSize2[0],
          height = _surface$getGLSize2[1];

      console.groupCollapsed("Surface draw");
      this.groupNestedLvl = 1;
      (0, _log.default)("_size_ `" + width + "`x`" + height + "`");
    }
  }, {
    key: "onSurfaceDrawError",
    value: function onSurfaceDrawError(e) {
      console.error(e);

      while (this.groupNestedLvl > 0) {
        console.groupEnd();
        this.groupNestedLvl--;
      }

      return true;
    }
  }, {
    key: "onSurfaceDrawEnd",
    value: function onSurfaceDrawEnd() {
      this.groupNestedLvl--;
      console.groupEnd();
    }
  }, {
    key: "onNodeDrawSkipped",
    value: function onNodeDrawSkipped(node) {
      (0, _log.default)(node.getGLName() + " redraw _skipped_: " + (!node.context.glSurface.gl ? "no gl context available!" : !node._needsRedraw ? "no need to redraw" : ""));
    }
  }, {
    key: "onNodeDrawStart",
    value: function onNodeDrawStart(node) {
      this.groupNestedLvl++;
      console.group(node.getGLName());
    }
  }, {
    key: "onNodeSyncDeps",
    value: function onNodeSyncDeps(node, additions, deletions) {
      if (additions.length) console.log(node.getGLName() + " +deps " + additions.map(function (n) {
        return n.getGLName();
      }).join(", "));
      if (deletions.length) console.log(node.getGLName() + " -deps " + additions.map(function (n) {
        return n.getGLName();
      }).join(", "));
    }
  }, {
    key: "onNodeDraw",
    value: function onNodeDraw(node, preparedUniforms) {
      var _node$props = node.props,
          blendFunc = _node$props.blendFunc,
          clear = _node$props.clear;
      this.groupNestedLvl++;
      console.group("DRAW " + node.getGLName());

      var _node$getGLSize = node.getGLSize(),
          _node$getGLSize2 = _slicedToArray(_node$getGLSize, 2),
          w = _node$getGLSize2[0],
          h = _node$getGLSize2[1];

      (0, _log.default)("_size_ `" + w + "`x`" + h + "` " + "_clear_ `" + JSON.stringify(clear) + "` " + "_blendFunc_ `" + JSON.stringify(blendFunc) + "`");
      (0, _log.default)("_" + preparedUniforms.length + " uniforms:_");
      preparedUniforms.forEach(function (obj) {
        var key = obj.key,
            type = obj.type,
            value = obj.value,
            getMetaInfo = obj.getMetaInfo;
        type = String(type || "UNKNOWN");
        var values = value === undefined ? "" : Array.isArray(value) ? "[" + value.map(function (v) {
          return "`" + String(v) + "`";
        }).join(",") + "]" : "`" + String(value) + "`";
        var spaces = "";

        for (var i = type.length + key.length - 18; i < 0; i++) {
          spaces += " ";
        }

        (0, _log.default).apply(void 0, ["".concat(spaces, "*").concat(type === "UNKNOWN" ? "[c='color:red']UNKNOWN[c]" : type, "* _").concat(key, "_ = ").concat(values)].concat(_toConsumableArray(getMetaInfo ? aggregateInfo(getMetaInfo()) : [])));
      });
    }
  }, {
    key: "onNodeDrawEnd",
    value: function onNodeDrawEnd() {
      this.groupNestedLvl -= 2;
      console.groupEnd();
      console.groupEnd();
    }
  }]);

  return VisitorLogger;
}(_Visitor.default);

exports.default = VisitorLogger;